<header>
  <app-header headerName="Officer"></app-header>
</header>

<div class="outer-conatiner">
  <div class="inner-container">
    <app-page-title pageTitle='Village of Volo Overnight Parking'></app-page-title>
    <section class="container-wrapper search-section">
      <form [formGroup]="searchForm" (ngSubmit)="onSubmitSearch1()">
        <div class="row">
          <div class="col-4">
            <mat-form-field class="mat-date-pick">
              <mat-label>State</mat-label>
              <!-- <input matInput formControlName="state"/> -->
              <mat-select formControlName="stateId" required>
                <mat-option *ngFor="let state of states" [value]="state.id">{{state.state}}</mat-option>
              </mat-select>
              <mat-error *ngIf="searchForm.get('stateId').hasError('required')">
                Please enter state
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-4">
            <mat-form-field class="mat-date-pick">
              <mat-label>Plate No.</mat-label>
              <input matInput formControlName="plateNo" pattern="^[a-zA-Z0-9\-_]{0,40}$"required />
              <mat-error *ngIf="searchForm.get('plateNo').hasError('required')">
                Please enter plate number
              </mat-error>
              <mat-error  *ngIf="!searchForm.get('plateNo').hasError('required') && searchForm.get('plateNo').hasError('pattern')">
                Plate.No. should be alphanumeric without spaces.
              </mat-error>
            </mat-form-field>
            <!-- <mat-error style="text-align: left; font-size: 75%; padding: 0px 35px;" *ngIf="!searchForm.get('plateNo').hasError('required') && searchForm.get('plateNo').hasError('patternValidation')">
            Plate.No should be start with single Alphanumeric and allow Alphanumeric with special characters
            </mat-error> -->
          </div>
          <div class="col-4 display-flex">
            <button mat-button class="button-primary" [disabled]='searchForm.invalid'
              color="vov-ui-primary">Search</button>
              <span ><button style="padding-top: 15px;" type="reset" class="semi-button semi-reset"  color="vov-ui-primary" (click)="reset()">Return to Reset</button></span> 
          </div>
        </div>
      </form>
    </section>
    <!-- <hr> -->
    <!-- {{searchResult && (searchForm.controls.plateNo.value != '' && searchForm.controls.stateId.value != '')}} -->
    <div *ngIf="searchResult && searchForm.controls.plateNo.value != '' &&  searchForm.controls.stateId.value != ''">
      <p class="sub-form-title ">Search Result</p>
      <!-- <p class="sub-text margin-auto sub-text-small">This vehicle is not registered for free parking or permitted parking</p> -->
      <div style="display:flex; align-items: center;">
      <p class="sub-text sub-text-small" style="margin-right:10px;"
        [ngStyle]="permitMessage=='VALID WAIVER' || permitMessage=='VALID PERMIT' || permitMessage=='VALID PERMIT && WAIVER'?{'color':'green'} : {'color': 'red'}">{{permitMessage}}</p>
        <p>{{messageWithDate}}</p></div>
        <p *ngIf="validWaiver" class="sub-form-title" [hidden]="valid">Waiver History</p>
        <section *ngIf="validWaiver" class="container-wrapper parking-history">
          <div class="box">
            <!-- <div class="export-button" *ngIf="enforcementData && enforcementData.length">
              <button mat-button (click)="exportAsXLSX()" color="vov-ui-primary"><i class="fa fa-upload"
                  aria-hidden="true"></i>Export CSV</button>
            </div> -->
            <mat-table #table [dataSource]="dataSource" matSort>
              <ng-container matColumnDef="plateNo">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Plate No.</mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.plateNo}} </mat-cell>
              </ng-container>
              <!-- <ng-container matColumnDef="state">
                <mat-header-cell *matHeaderCellDef mat-sort-header>State</mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.state}} </mat-cell>
              </ng-container> -->
                 <ng-container matColumnDef="createdAt">
                   <mat-header-cell *matHeaderCellDef mat-sort-header>Wavier date </mat-header-cell>
                   <mat-cell *matCellDef="let element"> {{element.startDate | date:'MM/dd/yyyy'}} </mat-cell>
                 </ng-container>
                 <!-- Symbol Column -->
                 <ng-container matColumnDef="streetNumber">
                   <mat-header-cell *matHeaderCellDef mat-sort-header> Street No.</mat-header-cell>
                   <mat-cell *matCellDef="let element"> {{element.streetNumber}} </mat-cell>
                 </ng-container>
                 <ng-container matColumnDef="street">
                   <mat-header-cell *matHeaderCellDef mat-sort-header> Street</mat-header-cell>
                   <mat-cell *matCellDef="let element"> {{element.streets.street}} </mat-cell>
                 </ng-container>
              <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
              <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
            </mat-table>

            <mat-paginator #paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
          </div>
        </section>
  
        <!-- <p [hidden]= 'true' *ngIf="validPermit" class="sub-form-title" [hidden]="valid">Permit History</p> -->
        <section [hidden]= 'true' *ngIf="validPermit" class="container-wrapper parking-history table-container">
          <div class="box">  
            <!-- <div class="export-button" *ngIf="enforcementData && enforcementData.length">
              <button mat-button (click)="exportAsXLSX()" color="vov-ui-primary"><i class="fa fa-upload"
                  aria-hidden="true"></i>Export CSV</button>
            </div> -->
            <mat-table #table [dataSource]="dataSourcePermit" matSort>
              <!-- <ng-container matColumnDef="state">
                <mat-header-cell *matHeaderCellDef mat-sort-header>State</mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.state}} </mat-cell>
              </ng-container> -->
              <ng-container matColumnDef="plateNo">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Plate No.</mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.plateNo}} </mat-cell>
              </ng-container>
                 <ng-container matColumnDef="startDate">
                   <mat-header-cell *matHeaderCellDef mat-sort-header>Waiver Date</mat-header-cell>
                   <mat-cell *matCellDef="let element"> {{element.startDate | date:'MM/yyyy'}} </mat-cell>
                 </ng-container>
              <mat-header-row *matHeaderRowDef="displayedPermitColumns"></mat-header-row>
              <mat-row *matRowDef="let row; columns: displayedPermitColumns;"></mat-row>
            </mat-table>

            <mat-paginator #permitPaginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
          </div>
        </section>
        <p class="sub-form-title" *ngIf="valid">Enforcement History</p>
      <section *ngIf="valid" class="container-wrapper parking-history table-container">
        <div class="box">
          <!-- <div class="export-button" *ngIf="enforcementData && enforcementData.length">
            <button mat-button (click)="exportAsXLSX()" color="vov-ui-primary"><i class="fa fa-upload"
                aria-hidden="true"></i>Export CSV</button>
          </div> -->
          <mat-table #table [dataSource]="dataSource" matSort>
            <!-- <ng-container matColumnDef="state">
              <mat-header-cell *matHeaderCellDef mat-sort-header>State</mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.states? element.states.state: null}} </mat-cell>
            </ng-container> -->
            <ng-container matColumnDef="plateNo">
              <mat-header-cell *matHeaderCellDef mat-sort-header>Plate No</mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.plateNo}} </mat-cell>
            </ng-container>
            <ng-container matColumnDef="date">
              <mat-header-cell *matHeaderCellDef mat-sort-header>Date</mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.date | date:'MM/dd/yyyy'}} </mat-cell>
            </ng-container>
            <ng-container matColumnDef="createdAt">
              <mat-header-cell *matHeaderCellDef mat-sort-header>Time </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.createdAt | date:'h:mm a'}} </mat-cell>
            </ng-container>
            <ng-container matColumnDef="action">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Action </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element?.action?.action ? element?.action?.action : '-'}} </mat-cell>
            </ng-container>
            <!-- Symbol Column -->
            <ng-container matColumnDef="streetNumber">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Street.No</mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.streetNumber? element.streetNumber : null}}
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="street">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Street</mat-header-cell>
              <mat-cell style="word-break: break-all;padding: 0px 10px;" *matCellDef="let element"> {{element.streets.street}} </mat-cell>
            </ng-container>
            <ng-container matColumnDef="userName">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Officer Id </mat-header-cell>
              <mat-cell style="word-break: break-all;padding: 0px 10px;" *matCellDef="let element"> {{element.user.userName}} </mat-cell>
            </ng-container>
            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
          </mat-table>
          <mat-paginator #paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
        </div>
      </section>
      <p [hidden]="!valid" class="sub-form-title">Enforcement Action</p>
      <p [hidden]="!valid" class="sub-text margin-auto sub-text-small">Choose a desired option to note vehicle details</p>
      <form [formGroup]="enforcementForm" (ngSubmit)="onSubmitEnforcement(formDirective)" #formDirective="ngForm">
        <section [hidden]="!valid" class="container-wrapper note-section">
          <!-- <form [formGroup]="enforcementForm" (ngSubmit)="onSubmitEnforcement()"> -->
          <mat-radio-group style ="padding-bottom: 10px;" aria-label="Select an option" formControlName="actionId">
            <mat-radio-button *ngFor="let action of actions" [value]="action.id" class="radio-cls">
              {{action.action}}</mat-radio-button>
            <!-- <mat-radio-button value="1" class="radio-cls">Internal note - Vehicle with no past offense</mat-radio-button>
        <mat-radio-button value="2" class="radio-cls">Warning - vehicle with internal note posted</mat-radio-button>
        <mat-radio-button value="3" class="radio-cls">Citation</mat-radio-button>
      </div> -->
          </mat-radio-group>
          <div class="row">
            <div class="col-6 row-cols">
              <mat-form-field>
              <mat-label>Street Number</mat-label>
              <input matInput formControlName="streetNumber" required/>
              <mat-error *ngIf="enforcementForm.get('streetNumber').hasError('required')">
                Please enter street number
              </mat-error> 
              </mat-form-field>
            </div> 
             <div class="col-6 row-cols">
              <mat-form-field>
                <mat-label>Street</mat-label>
                <mat-select formControlName="streetId" required>
                  <mat-option *ngFor="let street of streets" [value]="street.id">{{street.street}}</mat-option>
                </mat-select>
                <mat-error *ngIf="enforcementForm.get('streetId').hasError('required')">
                  Please enter street
                </mat-error> 
              </mat-form-field>
            </div>
            </div>

            <!-- <mat-form-field>
              <mat-label>Street No.</mat-label>
              <mat-select formControlName="streetNoId">
                <mat-option *ngFor="let streetNo of streetNumbers" [value]="streetNo.id">{{streetNo.streetNo}}
                </mat-option>
              </mat-select>
            </mat-form-field> -->
            <mat-form-field>
              <mat-label>Note (Optional)</mat-label>
              <input matInput formControlName="note" />
              <!-- <mat-error *ngIf="enforcementForm.get('note').hasError('required')">
                Please enter note
              </mat-error>  -->
            </mat-form-field>
            <button mat-button style="margin-top:15px;" class="button-primary" [disabled]='enforcementForm.invalid || btndisabled'
              color="vov-ui-primary">Submit</button>
            <!-- </form> -->
        </section>
      </form>
    </div>
  </div>
</div>
